export const financeManagerAllSelector = (state) =>
  state?.financeManagerReducer?.financeManagerAll;
export const financeManagerOpenAddSelector = (state) =>
  state?.financeManagerReducer?.financeManagerOpenAdd;
export const financeManagerOpenEditSelector = (state) =>
  state?.financeManagerReducer?.financeManagerOpenEdit;
export const financeManagerSelectedSelector = (state) =>
  state?.financeManagerReducer?.financeManagerSelected;
export const financeManagerSearchSelector = (state) =>
  state?.financeManagerReducer?.financeManagerSearch;
export const financeManagerDatesSelector = (state) =>
  state?.financeManagerReducer?.financeManagerDates;
